import {AfterViewInit, Component, OnInit} from '@angular/core';
import { map } from 'rxjs';
import { AuthorizationServiceProvider } from '../../services/authorization-service.provider';

@Component({
  selector: 'app-login-redirect-page',
  templateUrl: './login-redirect-page.component.html',
  styleUrls: ['./login-redirect-page.component.scss'],
  standalone: false
})
export class LoginRedirectPageComponent implements OnInit {
  constructor(private authServiceProv: AuthorizationServiceProvider) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.authServiceProv.getOnWebAuthorization().pipe(
        map(auth => auth.startLogin(''))
      ).subscribe();
    }, 1000);
  }
}
